import fan from '../../../../../../../services/fan';

export async function getGraphToken(graphId) {
  const result = await fan.get(`/graphs/${graphId}/token`);
  return result.data;
}
export default null;
